import { Action } from '@ngrx/store';
import { ActivitiesForm } from '@shared/models/activities-form';
import { CarForm } from '@shared/models/car-form';
import { FlightForm } from '@shared/models/flight-form';
import { HotelForm } from '@shared/models/hotel-form';
import { FormData } from '../../models/form-data';

export const INITIALIZE_DATE = '[Travel Search Form] Initialize travel search dates';
export const INITIALIZE_TRAVEL_SEARCH_FORM = '[Travel Search Form] Initialize travel search form';
export const SET_DEFAULT_START_DATE = '[Travel Search Form] Set default start date';
export const UPDATE_FLIGHT_FORM = '[Travel Search Form] Update flight form';
export const UPDATE_HOTEL_FORM = '[Travel Search Form] Update hotel form';
export const UPDATE_CAR_FORM = '[Travel Search Form] Update car form';
export const UPDATE_ACTIVITIES_FORM = '[Travel Search Form] Update activities form';
export const RESTORE_ACTIVITIES_FORM = '[Travel Search Form] Restore activities form';

export class InitializeDate implements Action {
  readonly type = INITIALIZE_DATE;
}
export class InitializeTravelSearchForm implements Action {
  readonly type = INITIALIZE_TRAVEL_SEARCH_FORM;
}

export class SetDefaultStartDate implements Action {
  readonly type = SET_DEFAULT_START_DATE;
  constructor(public payload: { startDate: string; endDate: string }) {}
}

export class UpdateFlightForm implements Action {
  readonly type = UPDATE_FLIGHT_FORM;
  constructor(public formData: FormData<FlightForm>) {}
}

export class UpdateHotelForm implements Action {
  readonly type = UPDATE_HOTEL_FORM;
  constructor(public formData: FormData<HotelForm>) {}
}

export class UpdateCarForm implements Action {
  readonly type = UPDATE_CAR_FORM;
  constructor(public formData: FormData<CarForm>) {}
}
export class UpdateActivitiesForm implements Action {
  readonly type = UPDATE_ACTIVITIES_FORM;
  constructor(public formData: FormData<ActivitiesForm>) {}
}

export class RestoreActivitiesForm implements Action {
  readonly type = RESTORE_ACTIVITIES_FORM;
}

export type TravelSearchFormActions =
  | InitializeDate
  | InitializeTravelSearchForm
  | SetDefaultStartDate
  | UpdateFlightForm
  | UpdateHotelForm
  | UpdateCarForm
  | UpdateActivitiesForm;
